import { Skeleton, Stack } from '@mui/material';

export const ScorecardBuilderFallback = () => {
  return (
    <Stack gap="1rem" mt="2rem">
      <Skeleton variant="rectangular" height="200px" width="100%" />
      <Skeleton variant="rectangular" height="200px" width="100%" />
    </Stack>
  );
};
